module.exports = __webpack_public_path__ + "static/media/2.74c66555.jpg";